import { useState, useEffect, useRef } from "react";
import { HiOutlineDocumentReport } from "react-icons/hi";
import Button from "../../../../../components/button/button";
import InputDropdown from "../../../../../components/inputs/inputDropdown/inputDropdown";
import InputCheckbox from "../../../../../components/inputs/inputCheckbox/inputCheckbox";
import CustomizedLabelLineChart from "../../../../../components/charts/customizedLabelLineChart";
import SimpleBarChart from "../../../../../components/charts/simpleBarChart";
import Popup from "../../../../../components/popup/popup";
import Notification from "../../../../../components/notification/notification";
import { getApiInstance } from "../../../../../utils/api";
import "./resumen.scss";

export default function Resumen({ user }) {
    const [isPopupProveedoresOpen, setIsPopupProveedoresOpen] = useState(false);
    const [isPopupTarifasOpen, setIsPopupTarifasOpen] = useState(false);
    const [solicitudes, setSolicitudes] = useState([]);
    const [tarifas, setTarifas] = useState([]);
    const [selectedTarifa, setSelectedTarifa] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [proveedores, setProveedores] = useState([]);
    const [selectedProveedores, setSelectedProveedores] = useState([]);
    const [tarifasAprobadas, setTarifasAprobadas] = useState([]);
    const [selectedTarifasAprobadas, setSelectedTarifasAprobadas] = useState(
        []
    );
    const [selectedMueble, setSelectedMueble] = useState(null);
    const notificationRef = useRef();
    const [mueblesOptions, setMueblesOptions] = useState([]);
    const [selectedMuebles, setSelectedMuebles] = useState([]);
    const [selectedTarifasGrafico, setSelectedTarifasGrafico] = useState([]);
    const [tarifasMuebles, setTarifasMueble] = useState([]);

    const fetchProveedores = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get("/api/Empresa/GetAllEmpresas");
            const proveedoresFiltrados =
                response.data?.filter(
                    (empresa) => empresa.tipoEmpresa === "Proveedor"
                ) || [];

            setProveedores(proveedoresFiltrados);
            setSelectedProveedores(
                proveedoresFiltrados.map((proveedor) => proveedor.codEmpresa)
            );
        } catch (error) {
            console.error("Error al obtener los proveedores:", error);
            setProveedores([]);
        }
    };

    const fetchAllTarifas = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get("/api/MueblesPrecios/Tarifas");

            setTarifas(
                response.data.map((tarifa) => ({
                    label: tarifa,
                    value: tarifa,
                }))
            );
        } catch (error) {
            console.error("Error al obtener los proveedores:", error);
            setTarifas([]);
        }
    };

    const fetchTarifasAprobadas = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get(
                `/api/MueblesPrecios/TarifasAprobadas/${user.codEmpresa}`
            );
            console.log(response);

            setTarifasAprobadas(
                response.data.map((tarifa) => ({
                    label: tarifa,
                    value: tarifa,
                }))
            );
            setSelectedTarifasAprobadas(response.data.map((tarifa) => tarifa));
        } catch (error) {
            console.error("Error al cargar tarifas aprobadas:", error);
            setError("No se pudieron cargar las tarifas aprobadas");
        }
    };

    const fetchSolicitudes = async () => {
        const api = getApiInstance();
        try {
            const response = await api.post(
                `/api/MueblesPrecios/GetMueblesPrecioByProveedorEstados/${user.codEmpresa}`,
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
            );
            setSolicitudes(response.data);
            setMueblesOptions(
                response.data
                    .filter(
                        (solicitud, index, self) =>
                            index ===
                            self.findIndex(
                                (item) => item.codMueble === solicitud.codMueble
                            )
                    )
                    .map((solicitud) => ({
                        label:
                            solicitud.nombreMueble +
                            " - " +
                            solicitud.referencia,
                        value: solicitud.codMueble,
                    }))
            );
        } catch (error) {
            console.error("Error al obtener las solicitudes:", error);
            setSolicitudes([]);
        }
    };

    useEffect(() => {
        fetchAllTarifas();
        fetchProveedores();
        fetchTarifasAprobadas();
        fetchSolicitudes();
    }, []);

    const handleTarifaChange = (selectedOption) => {
        setSelectedTarifa(selectedOption);
    };

    const handleOpenPopupProveedores = () => {
        setIsPopupProveedoresOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupProveedoresOpen(false);
    };

    const handleConfirmReportProveedores = () => {
        if (selectedProveedores.length === 0) {
            notificationRef.current.addNotification(
                "Selecciona al menos un proveedor antes de generar el informe.",
                "warning"
            );
            return;
        }
        handleExportExcel(true);
        setIsPopupProveedoresOpen(false);
    };

    const handleProveedorChange = (codEmpresa) => {
        setSelectedProveedores((prev) =>
            prev.includes(codEmpresa)
                ? prev.filter((id) => id !== codEmpresa)
                : [...prev, codEmpresa]
        );
    };

    const handleTarifasAprobadasChange = (tarifa) => {
        setSelectedTarifasAprobadas((prev) =>
            prev.includes(tarifa)
                ? prev.filter((id) => id !== tarifa)
                : [...prev, tarifa]
        );
    };

    const handleConfirmReportTarifas = () => {
        if (selectedTarifasAprobadas.length === 0) {
            notificationRef.current.addNotification(
                "Selecciona al menos una tarifa antes de generar el informe.",
                "warning"
            );
            return;
        }
        handleExportExcel(false);
        setIsPopupTarifasOpen(false);
    };

    const handleExportExcel = async (isProveedores) => {
        try {
            const api = getApiInstance();
            let response;
            if (isProveedores) {
                response = await api.post(
                    `/api/MueblesPrecios/InformeTarifaProveedores/${user.codEmpresa}/${selectedTarifa.value}`,
                    selectedProveedores,
                    { responseType: "blob" }
                );
            } else {
                response = await api.post(
                    `/api/MueblesPrecios/InformeTarifas/${user.codEmpresa}`,
                    selectedTarifasAprobadas,
                    { responseType: "blob" }
                );
            }

            if (response.status !== 200) {
                throw new Error("Error al descargar el archivo");
            }

            const blob = await response.data;

            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;

            let fileName = "InformeTarifaProveedores.xlsx";
            const disposition = response.headers.get("Content-Disposition");
            if (disposition && disposition.indexOf("filename=") !== -1) {
                const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                    fileName = fileNameMatch[1];
                }
            }
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            notificationRef.current.addNotification(
                "Archivo descargado correctamente.",
                "success"
            );
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al descargar el archivo.",
                "error"
            );
            console.error("Error al descargar el archivo:", error);
        }
    };

    const transformarDatosGenerico = (data, campoGrupo, campoBarra, campoY) => {
        const grupos = data.reduce((acumulador, registro) => {
            const clave = registro[campoGrupo];
            if (!acumulador[clave]) {
                acumulador[clave] = [];
            }
            acumulador[clave].push(registro);
            return acumulador;
        }, {});

        const datosGrafico = Object.keys(grupos).map((valorGrupo) => {
            const objetoGrafico = {
                nombre: valorGrupo,
                fechaSolicitud: formatDate(
                    grupos[valorGrupo][0]?.fechaSolicitud
                ),
            };

            grupos[valorGrupo].forEach((registro) => {
                objetoGrafico[registro[campoBarra]] = registro[campoY];
            });

            return objetoGrafico;
        });

        return datosGrafico;
    };

    function formatDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("es-ES"); // Formato dd/mm/yyyy
    }

    // primer grafico
    function filtrarMueblesTarifasGrafico(data, muebleId) {
        if (!muebleId || selectedTarifasGrafico.length === 0) return [];
            
        return filterAndGroupTarifas(
            data.filter(
                (item) =>
                    item.codMueble === muebleId &&
                    selectedTarifasGrafico.includes(item.nombreTarifa) &&
                    item.precioUnidad > 0
            ),
            "nombreTarifa"
        );
    }

    // segundo gráfico
    function filtrarMueblesParaComparativa(data) {
        if (selectedMuebles.length === 0) return [];

        const datosFiltrados = data.filter(
            (item) =>
                selectedMuebles.includes(item.codMueble) &&
                item.precioUnidad > 0
        );

        return filterAndGroupTarifas(datosFiltrados, "nombreMueble");
    }

    const filterAndGroupTarifas = (data, campoGrupo) => {
        const resultado = [];
        const gruposAceptados = [];
        const grupoNoAceptados = [];

        if (data.length === 0) {
            return [];
        }

        const grupos = data.reduce((acumulador, item) => {
            const clave = item[campoGrupo];
            if (!acumulador[clave]) {
                acumulador[clave] = [];
            }
            acumulador[clave].push(item);
            return acumulador;
        }, {});

        if (grupos.length === 0) {
            return [];
        }

        Object.keys(grupos).forEach((clave) => {
            const grupo = grupos[clave];
            if (grupo.some((item) => item.codEstado === 7)) {
                gruposAceptados.push(
                    grupo.filter((item) => item.codEstado === 7)
                );
            } else {
                grupoNoAceptados.push(grupo);
            }
        });

        gruposAceptados.forEach((grupo) => {
            resultado.push(...grupo);
        });

        if (grupoNoAceptados.length > 0) {
            let grupoMasReciente = grupoNoAceptados[0];

            // Definir la fecha máxima del primer grupo
            let maxFecha = new Date(
                Math.max(
                    ...grupoMasReciente.map(
                        (item) => new Date(item.fechaSolicitud)
                    )
                )
            );

            for (let i = 1; i < grupoNoAceptados.length; i++) {
                const grupoActual = grupoNoAceptados[i];
                const maxFechaGrupoActual = new Date(
                    Math.max(
                        ...grupoActual.map(
                            (item) => new Date(item.fechaSolicitud)
                        )
                    )
                );
                if (maxFechaGrupoActual > maxFecha) {
                    maxFecha = maxFechaGrupoActual;
                    grupoMasReciente = grupoActual;
                }
            }

            resultado.push(
                ...grupoMasReciente.filter((item) => item.precioUnidad !== 0)
            );
        }

        return resultado;
    };

    const handleSelectedMuebleChange = (selectedOption) => {
        setSelectedMueble(selectedOption.value);
        const agrupacion = filterAndGroupTarifas(
            solicitudes.filter(
                (x) =>
                    x.precioUnidad > 0 && x.codMueble === selectedOption.value
            ),
            "nombreTarifa"
        );

        setTarifasMueble(
            agrupacion
                .sort(
                    (a, b) =>
                        new Date(b.fechaSolicitud) - new Date(a.fechaSolicitud)
                )
                .map((x) => ({
                    label:
                        x.nombreTarifa +
                        " - " +
                        new Date(x.fechaSolicitud).toLocaleDateString(),
                    value: x.nombreTarifa,
                }))
                .filter(
                    (item, index, self) =>
                        index === self.findIndex((t) => t.value === item.value)
                )
        );
    };

    const handleSelectMuebles = (selectedIds) => {
        setSelectedMuebles(selectedIds);
    };

    const handleSelectTarifas = (selectedIds) => {
        // if(selectedIds.length > 1) {
        //     notificationRef.current.addNotification(
        //         "Selecciona un máximo de 3 tarifas.",
        //         "warning"
        //     );
        //     return;
        // }
        setSelectedTarifasGrafico(selectedIds);
    };

    return (
        <section className="resumen">
            <div className="resumen__table-header">
                <InputDropdown
                    label="Selecciona un mueble"
                    options={mueblesOptions}
                    onSelect={handleSelectedMuebleChange}
                    value={selectedTarifa}
                    isLoading={loading}
                    isDisabled={loading || error}
                    hasSearch={true}
                />
                <InputDropdown
                    label="Selecciona las tarifas"
                    options={tarifasMuebles}
                    onSelect={handleSelectTarifas}
                    hasSearch={true}
                    withCheckboxes={true}
                />
                <div className="resumen__table-header__buttons">
                    <Button
                        variant="filled"
                        label="Informe tarifa proveedores"
                        icon={<HiOutlineDocumentReport />}
                        onClick={handleOpenPopupProveedores}
                    />
                    <Button
                        variant="filled"
                        label="Informe tarifas"
                        icon={<HiOutlineDocumentReport />}
                        onClick={() => setIsPopupTarifasOpen(true)}
                    />
                </div>
            </div>

            {/* <div>
                <CustomizedLabelLineChart hasCustomizedLabels={false} />
            </div> */}
            <div>
                {/* Primer gráfico  */}
                {!selectedMueble || selectedTarifasGrafico.length === 0 ? (
                    <div className="grafico-placeholder">
                        <p>
                            {!selectedMueble
                                ? "Selecciona un mueble para ver el gráfico"
                                : "Selecciona al menos una tarifa para ver el gráfico"}
                        </p>
                    </div>
                ) : (
                    <SimpleBarChart
                        data={transformarDatosGenerico(
                            filtrarMueblesTarifasGrafico(
                                solicitudes,
                                selectedMueble
                            ),
                            "nombreTarifa",
                            "nombreEmpresa",
                            "precioUnidad"
                        )}
                        hasTitle={true}
                        xAxisKey="nombre"
                        title="Comparativa de muebles y tarifas por proveedor"
                    />
                )}
            </div>

            <div style={{ marginTop: "40px" }}>
                <div style={{ marginBottom: "24px" }}>
                    <InputDropdown
                        label="Selecciona los muebles para comparar"
                        options={mueblesOptions}
                        onSelect={handleSelectMuebles}
                        withCheckboxes={true}
                        hasSearch={true}
                    />
                </div>

                {selectedMuebles.length === 0 ? (
                    <div className="grafico-placeholder">
                        <p>
                            Selecciona al menos un mueble para ver la
                            comparativa
                        </p>
                    </div>
                ) : (
                    <SimpleBarChart
                        data={transformarDatosGenerico(
                            filtrarMueblesParaComparativa(solicitudes),
                            "nombreMueble",
                            "nombreTarifa",
                            "precioUnidad"
                        )}
                        hasTitle={true}
                        xAxisKey="nombre"
                        title="Comparativa de muebles por tarifa"
                    />
                )}
            </div>

            {error && <div className="resumen__error-message">{error}</div>}

            {/* Popup informes proveedores*/}
            {isPopupProveedoresOpen && (
                <Popup
                    type="info"
                    titleMessage={
                        "¿Deseas generar un informe de tarifas por proveedor?"
                    }
                    onConfirm={handleConfirmReportProveedores}
                    onClose={handleClosePopup}
                    confirmLabel="Generar"
                    cancelLabel="Cancelar"
                    children={
                        <form className="gestion-muebles__modal__form">
                            <div className="gestion-muebles__modal__form__input">
                                <h2 style={{ marginBottom: "16px" }}>
                                    Selecciona la tarifa del informe
                                </h2>
                                <InputDropdown
                                    showLabel={false}
                                    placeholder="Selecciona una tarifa"
                                    options={tarifas}
                                    onSelect={handleTarifaChange}
                                    value={selectedTarifa}
                                    isLoading={loading}
                                    isDisabled={loading || error}
                                />
                            </div>
                            <div className="gestion-muebles__modal__form__input">
                                <h2 style={{ marginBottom: "16px" }}>
                                    Selecciona los proveedores del informe
                                </h2>
                                {proveedores.map((proveedor) => (
                                    <InputCheckbox
                                        key={proveedor.codEmpresa}
                                        label={proveedor.nombre}
                                        checked={selectedProveedores.includes(
                                            proveedor.codEmpresa
                                        )}
                                        onChange={() =>
                                            handleProveedorChange(
                                                proveedor.codEmpresa
                                            )
                                        }
                                    />
                                ))}
                            </div>
                        </form>
                    }
                />
            )}

            {/* Popup informe tarifas */}
            {isPopupTarifasOpen && (
                <Popup
                    type="info"
                    titleMessage="¿Deseas generar un informe resumen da las tarifas?"
                    onConfirm={handleConfirmReportTarifas}
                    onClose={() => setIsPopupTarifasOpen(false)}
                    confirmLabel="Generar"
                    cancelLabel="Cancelar"
                    children={
                        <form className="gestion-muebles__modal__form">
                            <div className="gestion-muebles__modal__form__input">
                                <h2 style={{ marginBottom: "16px" }}>
                                    Selecciona las tarifas del informe
                                </h2>
                                {tarifasAprobadas.map((tarifa) => (
                                    <InputCheckbox
                                        key={tarifa.value}
                                        label={tarifa.value}
                                        checked={selectedTarifasAprobadas.includes(
                                            tarifa.value
                                        )}
                                        onChange={() =>
                                            handleTarifasAprobadasChange(
                                                tarifa.value
                                            )
                                        }
                                    />
                                ))}
                            </div>
                        </form>
                    }
                />
            )}
            <Notification ref={notificationRef} />
        </section>
    );
}
